import { makeAutoObservable } from 'mobx';
import chatStorage from '../pages/Chat/chatStorage';

class ContactsModel {
  id = null;

  type = null;

  value = null;

  perfectum_id = null;

  constructor(contacts, autoObservable = true) {
    if (contacts) {
      this.id = contacts.id;
      this.type = contacts.type;
      this.value = contacts.value;
      this.perfectum_id = contacts.perfectum_id;
    }
    if (autoObservable) {
      makeAutoObservable(this);
    }
  }

  changeValue = (field, value) => {
    this.value = value;
    chatStorage.setChangedStatusForField(field, true);
  }
}

export default ContactsModel;
